export default __webpack_public_path__ + "static/media/background.bd4bd820.jpg";